import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';
import type { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';

import * as yup from 'yup';

/** Client's transit task limits by car category response body - DTO signature */
export interface TransitTaskCarCategoryLimitFindInterface {
  /** Related car category */
  category: CarCategoryFindInterface;
  /** Limit value */
  limit: number;
  /** Total transit task vehicles in the parking */
  total?: number;
}

/** Client's transit task limits by car category response body - DTO schema */
export const TransitTaskCarCategoryLimitFindDto = SerdeDtoClass.create<TransitTaskCarCategoryLimitFindInterface>(
  ClientDtoKeysEnum.TRANSIT_TASK_CAR_CATEGORY_LIMIT_FIND_DTO,
  {
    category: {
      label: 'Категория ТС',
      nested: CctvDtoKeysEnum.CAR_CATEGORY_FIND_DTO,
      serializer: (_, nested) => nested,
    },
    limit: {
      label: 'Лимит гостевых ТС',
      serializer: yup.number(),
    },
    total: {
      label: 'Сколько запарковано гостевых ТС сейчас',
      serializer: yup.number(),
    },
  },
);
